import { Form } from '@mairistem/composants';
import { Combobox, Panel } from '@mairistem/finances-utils';
import React from 'react';
import { toast } from 'react-toastify';
import { MULTI } from '@mairistem/comptabilite';
import { isString, isUndefined, isNull } from 'lodash';
import CustomCheckbox from '../../Common/CustomCheckbox';
import PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';
import './TravauxEnRegieComponent.less';
import { createTravauxRegie } from '../../../services/piecesComptables/travauxRegie';

const TravauxEnRegieComponent = ({
  data,
  handlePin,
  onChange,
  panel,
  setPanelOptions,
}: PanelComponentProps) => {
  const handleAddProduit = async (e, { name, value }) => {
    try {
      const travauxRegieData = await createTravauxRegie({ libelle: value });

      setPanelOptions((old) => ({
        ...old,
        travauxEnRegie: [...old.travauxEnRegie, {
          text: travauxRegieData.libelle,
          value: travauxRegieData.identifiant,
          key: travauxRegieData.identifiant,
          'data-testid': `travauxRegie${travauxRegieData?.identifiant}`,
        }],
      }));
      onChange?.({ [name]: travauxRegieData?.identifiant }, panel);
    } catch {
      toast.error('Impossible de récupérer les travaux en régies');
    }
  };

  const handleChange = (e, { name }) => onChange?.({ [name]: !data?.cocheTravauxRegie }, panel);

  const handleChangeLibelleProduit = (e, { name, value }) => {
    if (!isString(value)) onChange?.({ [name]: value }, panel);
  };

  return (
    <Panel panel={panel} onPin={handlePin}>
      <Form>
        <Form.Group>
          <Form.Input
            checked={data?.cocheTravauxRegie}
            className="travauxRegieCheckbox"
            control={CustomCheckbox}
            data-testid="travauxRegieCheckbox"
            indeterminate={isUndefined(data?.cocheTravauxRegie) ? false : !!isNull(data?.cocheTravauxRegie)}
            label="A immobiliser"
            name="cocheTravauxRegie"
            onChange={handleChange}
            width={5}
          />
          <Form.Field
            // @ts-expect-error
            additionLabel="Ajouter "
            allowAdditions
            control={Combobox}
            data-testid="travauxRegieDropdown"
            disabled={!data?.cocheTravauxRegie}
            key="identifiantTravauxRegie"
            label="Produit"
            name="identifiantTravauxRegie"
            onAddItem={handleAddProduit}
            onChange={handleChangeLibelleProduit}
            options={data?.travauxEnRegie ?? []}
            placeholder={data?.identifiantTravauxRegie === MULTI ? MULTI : ''}
            search
            selection
            value={data?.identifiantTravauxRegie}
            width={11}
          />
        </Form.Group>
      </Form>
    </Panel>
  );
};

export default TravauxEnRegieComponent;
